// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.chart-hover-tooltip {
  position: fixed;
  z-index: 10000;
  max-width: 280px;
  padding: 6px 10px;
  border-radius: 6px;
  background: #1f2937;
  color: #fff;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.35;
  pointer-events: none;
  transform: translate(-50%, -100%);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./app/javascript/components/ChartHoverTooltip.vue"],"names":[],"mappings":";AAuBA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,iCAAiC;EACjC,0CAA0C;EAC1C,mBAAmB;AACrB","sourcesContent":["<template>\n  <Teleport to=\"body\">\n    <div\n      v-if=\"tip\"\n      class=\"chart-hover-tooltip\"\n      :style=\"{ left: `${tip.x}px`, top: `${tip.y}px` }\"\n      role=\"tooltip\"\n    >\n      {{ tip.text }}\n    </div>\n  </Teleport>\n</template>\n\n<script setup>\ndefineProps({\n  tip: {\n    type: Object,\n    default: null,\n  },\n});\n</script>\n\n<style>\n.chart-hover-tooltip {\n  position: fixed;\n  z-index: 10000;\n  max-width: 280px;\n  padding: 6px 10px;\n  border-radius: 6px;\n  background: #1f2937;\n  color: #fff;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.35;\n  pointer-events: none;\n  transform: translate(-50%, -100%);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  white-space: nowrap;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
